import { useEffect } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { Show } from "@clerk/react";
import { UsersThree } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";

export const JOIN_KEY = "cr-join-token";

export default function Join() {
  const [params] = useSearchParams();
  const token = params.get("token");
  useEffect(() => { if (token) localStorage.setItem(JOIN_KEY, token); }, [token]);
  return (
    <div data-testid="join-page" className="min-h-screen bg-[#050505] text-white">
      <header className="border-b border-[#2A2A2A] px-6 h-16 flex items-center max-w-4xl mx-auto"><Logo /></header>
      <Show when="signed-in"><Navigate to="/app" replace /></Show>
      <Show when="signed-out">
        <main className="max-w-md mx-auto px-6 py-20">
          <UsersThree size={32} className="text-[#00FF9D]" />
          <h1 className="mt-4 font-display text-3xl font-semibold">You've been invited to a CalibRunway team</h1>
          <p className="mt-3 text-sm text-[#A3A3A3]">{token ? "Create an account or sign in with the email address the invite was sent to. You'll join the team right after."
            : "This invite link is missing its code. Open the link from your invite email again."}</p>
          {token && (
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/sign-up" data-testid="join-signup-btn" className="rounded-full bg-[#00FF9D] px-6 py-3 text-sm font-semibold text-[#050505]">Create account</Link>
              <Link to="/sign-in" data-testid="join-signin-btn" className="rounded-full border border-[#2A2A2A] px-6 py-3 text-sm hover:border-white transition-colors">I already have an account</Link>
            </div>
          )}
        </main>
      </Show>
    </div>
  );
}
